export const form = {
	selector: {
		languageSelect: '.js-feedback-reply-template-languages',
		htmlTextArea: '.js-feedback-reply-template-html',
	},
}
